export default __webpack_public_path__ + "0aa88df.png";